// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import LastExecution from './view'

export default function LastExecutionFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/App/Account/Content/Financial/Content/Statements/New/LastExecution">
      <LastExecution {...props}>
        {children}
      </LastExecution>
    </Flow>
  )
}
